






































































































































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import DialogLoad from '@/pantallas/Importar/Conversor/DialogLoad.vue';
import { parseKmz } from '@/pantallas/Importar/Conversor/parseKmz';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { LoadingService } from '@/services/loadingService';
import store from '@/store';

@Component({
  components: { DialogLoad },
})
export default class Conversor extends Vue {
  // State
  @Prop({default: "0"}) tabModel: string;
  axiosPy: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  dialog: boolean = false;
  dragover: boolean = false;
  multiple: any = false;
  uploadedFiles: any[] = [];
  emptyList: boolean = true;
  radioGroupExport: string = 'track3';
  radioGroupTrack3Type: string = 'sitios';
  radioGroupTDownloadType: string = 'allPolygon';
  files: File[] = [];
  $snotify: any;
  resultExport: number = 0;
  track3Export: boolean = true;
  isDirector: boolean = true;
  items: any[] = [];
  btnExport: string = "Exportar Csv";
  tfImportFile: string = "Selecciona tu archivo o arrastra aquí";
  tfLabelImport: string = "Archivos";
  fileInputKey: number = 0;
  loadingService = new LoadingService();

  @Watch('items')
  onItemsChanged(value: [], oldValue: []) {
    if (this.items.length > 0) {
      this.emptyList = false;
    } else {
      this.emptyList = true;
    }
  }

  @Watch('tabModel', {immediate: true})
  onTabChanged(value: [], oldValue: []) {
    if(this.tabModel == "0"){
      this.btnExport = "Exportar Csv";
      this.tfImportFile = "Selecciona tu archivo o arrastra aquí";
      this.radioGroupExport = 'track3';
      this.tfLabelImport = 'Archivos';
      this.radioGroupTrack3Type = 'sitios';
      this.radioGroupTDownloadType = 'allPolygon';
    }else{
      this.btnExport = "Exportar";
      this.tfImportFile = "Selecciona tu archivo .csv (exportado desde director) o arrastra aquí";
      this.tfLabelImport = "Archivo";
      this.radioGroupTrack3Type = "Track3";
      this.radioGroupTDownloadType = "Sitios";
    }
    this.files = [];
    this.items = [];
  }

  valideRadioGroupDirector(){
    if(this.radioGroupTrack3Type == "Orvis"){
      this.radioGroupTDownloadType = "Sitios";
    }
  }

  @Watch('files')
  onFilesChanged(value: [], oldValue: []) {
    var fileExtension: string = '';
    for (var file of this.files) {
      fileExtension = file.name.split('.').pop();
      if(this.tabModel == "0"){
        if (fileExtension != 'kmz') {
          this.$snotify.error('Todos los archivos ingresados deben ser .kmz');
          this.files = [];
          this.items = [];
          break;
        }
      }else{
        if (fileExtension != 'csv') {
          this.$snotify.error('El archivo ingresado debe ser .csv');
          this.files = [];
          this.items = [];
          break;
        }
      }
    }

    if(this.files.length == 0){
      this.fileInputKey+=1;
    }
  }

  @Watch('resultExport')
  onResultChanged(value: number, oldValue: number) {
    //console.log(this.resultExport);
  }

  @Watch('radioGroupExport')
  onRadioGroupChanged(value: string, oldValue: string) {
    if (value == 'director') {
      this.isDirector = false;
    } else {
      this.isDirector = true;
    }
  }

  erase(position: number) {
    this.items.splice(position, 1);
    this.fileInputKey+=1;
  }

  async exportCsv() {
    let self = this;
    if(this.tabModel == "0"){
      var excludedList: any[] = [];
      for (var file of this.files) {
        excludedList = await this.parseFile(file);
        if (excludedList.length > 0) {
          this.$snotify.success(
            'Se excluyeron los siguientes polígonos por exceder el límite de 50 puntos: ' +
              excludedList.join(' - ')
          );
        }
      }
      this.$snotify.success(
        'Todos los archivos se han exportado a Csv con éxito'
      );
    }else{
      // Envío 
      if(this.files.length > 0){
        const reader = new FileReader();

        // Declarando la función a correr al leer el archivo
        reader.onload = (event) => {
          const arrayBuffer = reader.result;
          self.convertCsv(arrayBuffer);
        };

        // Declarando la función a correr al fallar el archivo
        reader.onerror = (error) => {
          console.log(error)
          this.$snotify.error('Error al procesar el archivo csv.');
        };

        reader.readAsArrayBuffer(this.files[0]);
      }
    }
  }

  async convertCsv(file: any){
    this.loadingService.showLoading()
    // se procesa el nombre; se elimina el caracter "&"" para que no genere problemas en el servidor
    const filename: string = this.files[0].name.replaceAll("&", "_");
    let userid =  store.state.userId;
    // Se convierte el archivo a binario para enviarlo al servicio
    const uint8Array = new Blob([file])
    this.axiosPy.http.post(`Metabase/PostgenericA/conversor_director/post_conversor_director?vZExport=${this.radioGroupTDownloadType}&vPDestino=${this.radioGroupTrack3Type}&vFileName=${filename}&vUsuarioId=${userid}`,uint8Array,
    {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
    })
    .then((response:any) => {
      if (response.data.hasOwnProperty('CODIGO_RESPUESTA') && response.data.CODIGO_RESPUESTA == '2') {
        // Se notifica que hubo un error en el servicio al procesar el archivo
        this.$snotify.error(response.data.MENSAJE_RESPUESTA);
      } else {
        // Se obtiene el filename del headers, del campo content-disposition
        const fileName = this.getFilename(response.headers["content-disposition"], (this.radioGroupTrack3Type == 'Orvis' ? 'importar.kml' : 'importacion.csv')) 
        
        // Se descarga el archivo entrante en el navegador
        this.downloadFile(response.data, fileName);
      }
    })
    .catch((error: any) => {
      console.log("error:",error)
    })
    .finally(()=> {
      this.loadingService.hideLoading();
    })
  }


  getFilename(contentDisposition: string, defaultFilename: string){
    // extrae el fileName del header, ejemplo:  response:  attachment; filename="20240201115902_importar_track3.csv"
    let matches = contentDisposition.match(/filename="(.+?)"/);
    return (matches && matches[1] ? matches[1] : defaultFilename);
  }

  downloadFile(data: any, filename: string){
    // Obtener formato a descargar
    let format = (filename.endsWith('.csv') ? 'text/csv' : 'application/xml');

    // Procesa el archivo
    //let arrayBuffer = data.arrayBuffer();
    const blob = new Blob([data], { type: format });

    // Genera un elemento en el DOM para almacenar el archivo y descargarlo
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;  

    // Agrega el enlace al DOM y hace clic en él para iniciar la descarga
    document.body.appendChild(link);
    link.click();
  }

  onSelectFile(e: any) {
    console.log(e);
    if(e.target.files != undefined && e.target.files.length > 1){
      this.$snotify.error('Solo se puede ingresar un archivo a la vez.');
      return;
    }
    this.files = e.target.files;
    this.items = Array.from(e.target.files);
    return;
  }

  async parseFile(file: any) {
    const fil = await parseKmz(
      file,
      this.radioGroupExport,
      this.radioGroupTrack3Type,
      this.radioGroupTDownloadType
    );
    return fil;
  }

  onDrop(e: any) {
    this.dragover = false;
    if(e.dataTransfer.files != undefined && e.dataTransfer.files.length > 1){
      this.$snotify.error('Solo se puede ingresar un archivo a la vez.');
      return;
    }
    this.files = e.dataTransfer.files;
    this.items = Array.from(e.dataTransfer.files);
    //this.parseFile(this.files[0])
  }
}
